import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_RECEIPTS = `${URL_RETAILER_SCOPED}${URL_SITE_SCOPED}/receipts`
const URL_RECEIPTS_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/receipts`
const URL_RECEIPTS_LIST = `${URL_RECEIPTS_PARTNER_SCOPED}/list`
const URL_RECEIPTS_EDIT = `${URL_RECEIPTS}/edit/:contentPageId?`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  'receipts' | 'receipts-partner-scoped' | 'receipts-list' | 'receipts-edit'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  receipts: URL_RECEIPTS,
  'receipts-partner-scoped': URL_RECEIPTS_PARTNER_SCOPED,
  'receipts-list': URL_RECEIPTS_LIST,
  'receipts-edit': URL_RECEIPTS_EDIT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
